import React, { useEffect, useRef } from "react";
import Slider from "react-slick";
import styled from "styled-components";
import ReactReadMoreReadLess from "react-read-more-read-less";
import NextImage from "next/image";

import { Box, FlexDiv, Container } from "@/components/Atoms";

import Typography from "@/foundation/Typography/V1";
import theme from "@/foundation/Theme";

function MeetInstructor(props) {
  const { isMobile = false, removeFixBtn, data } = props || {};
  const slider = useRef(null);
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    swipeToSlide: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 2.5,
          dots: false,
          infinite: false,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.25,
          dots: false,
          infinite: false,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  useEffect(() => {
    let sliders = slider;
    setTimeout(() => {
      if (sliders.current) {
        sliders.current.slickGoTo(0);
      }
    }, 2000);
  }, [data]);
  return (
    <Wrapper
      bg={theme.colors.lightBlue}
      borderRadius={!isMobile && "33px 33px 0 0"}
      p={"51px 0 46px 0"}
      ref={removeFixBtn}
    >
      <TestimonialContainer>
        <Text
          variant="heading2"
          color={theme.colors.gray_100}
          maxWidth={["230px", "100%", "100%"]}
          textAlign="center"
        >
          {data?.title}
        </Text>
        <SliderWrapper maxWidth={"100%"} isMobile={isMobile}>
          <Slider ref={slider} {...settings}>
            {data?.instructors?.map((data, index) => {
              return (
                <CardWrapper key={index}>
                  <InnerWrap bg={theme.colors.white}>
                    {data.image && (
                      <ImgBox>
                        <div
                          style={{
                            position: "relative",
                            width: "100%",
                            height: "100%",
                          }}
                        >
                          <NextImage
                            src={data?.image}
                            fill={true}
                            style={{ objectFit: "cover" }}
                          />
                        </div>
                      </ImgBox>
                    )}
                    <Typography
                      color={theme.colors.link2Color}
                      variant="title1"
                      mb={"18px"}
                    >
                      {data?.instructor_name}
                    </Typography>
                    <Description
                      color={theme.colors.gray_90}
                      variant={"paragraph3"}
                    >
                      <ReactReadMoreReadLess
                        charLimit={200}
                        readMoreText={"Read more"}
                        readLessText={"Read less"}
                      >
                        {data?.about_instructor}
                      </ReactReadMoreReadLess>
                    </Description>
                    {/* <Typography
                      color={theme.colors.gray_80}
                      variant={"paragraph3"}
                    >
                      {data?.instructor_designation}
                    </Typography> */}
                  </InnerWrap>
                </CardWrapper>
              );
            })}
          </Slider>
        </SliderWrapper>
      </TestimonialContainer>
    </Wrapper>
  );
}

export default MeetInstructor;

const Wrapper = styled(FlexDiv)``;
const SliderWrapper = styled(Box)`
  ${({ isMobile }) =>
    !isMobile &&
    `
    .slick-prev,
    .slick-next {
        top: -20px;
        display: block !important;
        height: 38px;
        width: 38px;
        &:before {
        height: 100%;
        width: 100%;
        content: "";
        background: url("/images/button-arrow.svg") center no-repeat;
        background-size: 100%;
        display: block;
        }
    }
    .slick-next {
        right: 0;
    }
    .slick-prev {
        left: unset;
        right: 45px;
        &:before {
        transform: rotateY(180deg);
        }
    }
`};
  .slick-track {
    display: flex !important;
  }

  .slick-slide {
    height: auto !important;
  }
  .slick-list {
    padding: 30px 0;
  }
  .slick-slide {
    > div {
      display: flex;
      height: 100%;
      margin-right: 16px;
      @media only screen and (max-width: 1024px) {
        margin-right: 13px;
      }
    }
    &:last-child {
      > div {
        @media only screen and (max-width: 1024px) {
          margin-right: 13px;
        }
      }
    }
  }
  @media only screen and (max-width: 1024px) {
    padding-left: 15px;
  }
`;
const InnerWrap = styled(FlexDiv)`
  flex-direction: column;
  position: relative;
  padding: 55px 36px;
  border: 1px solid ${theme.colors.border4};
  border-radius: 10px;
  text-align: center;
  flex: 1;
`;
const ImgBox = styled(FlexDiv)`
  height: 84px;
  width: 84px;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: ${theme.colors.white};
  border: 2px solid ${theme.colors.white};
  border-radius: 50%;
  overflow: hidden;
  img {
    object-fit: cover;
    height: 100%;
    width: 100%;
  }
`;
const CardWrapper = styled(FlexDiv)`
  padding: 42px 0 0 0;
  position: relative;
  display: flex !important;
  flex-direction: column;
  flex: 1;
  outline: 0;
`;
const TestimonialContainer = styled(Container)`
  @media only screen and (max-width: 1024px) {
    padding-left: 0;
    padding-right: 0;
  }
`;
const Text = styled(Typography)`
  @media only screen and (max-width: 1024px) {
    padding-left: 15px;
  }
`;
const Description = styled(Typography)`
  .react-read-more-read-less {
    font-size: inherit;
    font-family: var(--font-700);
    color: ${theme.colors.link2Color};
  }
`;
